import BModal from "@/components/singles/BModal/component.vue";
import getSymbolFromCurrency from "currency-symbol-map";

export default {
  name: "",
  components: { BModal },
  props: ["item"],
  data() {
    return {
      showModal: false,
      firstLoadDone: false
    };
  },
  computed: {},
  async created() {},
  async mounted() {},
  methods: {
    GetSymbol(currency) {
      return getSymbolFromCurrency(currency);
    },

    Print() {
      window.print();
    },
    Show() {
      this.$set(this, "showModal", true);
      this.showModal = true;
    }
  }
};
